import type { GuitarChart } from '../guitarChart.js';
import type { Variant } from '../gameTypes.js';
import { PALETTE_GLACIER } from '../builtinPulseMaps/palettes.js';
import { assembleImportedGuitarChart } from './importedGuitarChart.js';
import normalImported from './imported/hollah-normal.guitar.json' with { type: 'json' };
import hardImported from './imported/hollah-hard.guitar.json' with { type: 'json' };
import extremeImported from './imported/hollah-extreme.guitar.json' with { type: 'json' };

export const HOLLAH_GUITAR_VARIANTS: Record<Variant, GuitarChart> = assembleImportedGuitarChart({
  baseSlug: 'hollah',
  baseTitle: "Cloud 9",
  description: "Itro & Tobu's Cloud 9 chilled mania set by rinaldi28 + Ly0. Three diffs ramp from beginner-easy to dense Insane streams.",
  difficulty: 4,
  palette: PALETTE_GLACIER,
  audioSrc: '/audio/guitar/hollah.mp3',
  attribution: "\"Cloud 9\" by Itro & Tobu [NCS Release] - https://ncs.io/cloud9",
  imported: {
    normal: normalImported,
    hard: hardImported,
    extreme: extremeImported,
  },
});
